import React from "react";
import { TagType } from "../../Structures";

interface TagProps {
  tag: TagType;
  wrapperClass?: string
}

const Tag = ({ tag, wrapperClass }: TagProps) => {
  return (
    <span className={`${wrapperClass} badge text-bg-${tag.color} me-1 mb-2`}>
      <i className="fas fa-circle me-1 small fw-bold"></i>
      {tag.title}
    </span>
  );
};

export default Tag;
